<template>
    <div class="pay_unit_price">
        <div class="tree-wrap">
            <me-tree
                ref="myTree"
                :treeData="treeData"
                :treeLoading="treeLoading"
                :treeToolBar="false"
                :defaultProps="defaultProps"
                :nodeKey="'point_class_id'"
                :showCheckbox="true"
                title="类型"
                :checkStrictly.sync="checkStrictly"
                :isCheckClick="true"
                :isSingle="true"
                :defaultCheckKeys="defaultCheckKeys"
                @handleCheckBoxClick="handleTreeNodeClick"
            ></me-tree>
        </div>
        <div class="table-wrap">
            <div style="text-align: right;margin-bottom: 0.5rem;">
                <el-button class="leader-common-button" @click="addEdit('新增')"
                    >新增</el-button
                >
            </div>

            <el-scrollbar style="height: 85%">
                <el-table :data="tableData" class="leader-style-table">
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>
                                {{
                                    (paginationData.pageNum - 1) *
                                        paginationData.pageSize +
                                        scope.$index +
                                        1
                                }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column
                        prop="pay_unit_price_name"
                        label="价格名称"
                    ></el-table-column>
                    <el-table-column
                        prop="remark"
                        label="备注"
                    ></el-table-column>
                    <el-table-column label="操作" width="200">
                        <template slot-scope="scope">
                            <el-button
                                type="text"
                                @click="priceClick(scope.row)"
                                >价格</el-button
                            >
                            <el-button
                                type="text"
                                @click="addEdit('修改', scope.row)"
                                >修改</el-button
                            >
                            <el-button type="text" @click="deleteRow(scope.row)"
                                >删除</el-button
                            >
                        </template>
                    </el-table-column>
                </el-table>
            </el-scrollbar>
            <pagination
                class="leader-style-pagination"
                :paginationData="paginationData"
                @paginationDataNew="paginationDataNew"
            ></pagination>
        </div>
        <el-dialog
            :title="outTitle"
            :visible.sync="outVisible"
            width="50%"
            class="leader-dialog"
            @close="closeOutDialog"
        >
            <el-form
                :model="outForm"
                ref="outForm"
                label-width="100px"
                :rules="outFormRules"
                class="leader-style-form"
            >
                <el-form-item label="价格名称" prop="pay_unit_price_name">
                    <el-input
                        v-model="outForm.pay_unit_price_name"
                        maxlength="200"
                        placeholder="请输入价格名称"
                    ></el-input>
                </el-form-item>
                <el-form-item label="备注" prop="remark">
                    <el-input
                        type="textarea"
                        rows="3"
                        v-model="outForm.remark"
                        maxlength="500"
                        placeholder="请输入备注"
                    ></el-input>
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="closeOutDialog"
                    >取消</el-button
                >
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="outSave"
                    >保存</el-button
                >
            </div>
        </el-dialog>
        <el-dialog
            title="价格维护"
            :visible.sync="innerVisible"
            width="70%"
            class="leader-dialog"
            @click="closeInnerDialog"
        >
            <el-form
                :model="innerForm"
                ref="innerForm"
                class="leader-style-form"
            >
                <div
                    style="display: flex;justify-content: space-between;margin-bottom: 1rem;color: #56fcff;font-size: 1rem;"
                >
                    <div>名称：{{ this.selectPriceName }}</div>
                    <el-button
                        size="medium"
                        class="leader-common-button"
                        @click="handleAddItem()"
                        :disabled="addDisabled"
                        >新增</el-button
                    >
                </div>
                <el-table
                    border
                    :data="innerForm.tableData"
                    class="leader-style-table custom-table"
                >
                    <el-table-column width="50" align="center" label="序号">
                        <template slot-scope="scope">
                            <span>
                                {{ scope.$index + 1 }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="开始时间" align="center">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'tableData.' + scope.$index + '.from_date'
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择开始时间',
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-date-picker
                                    type="date"
                                    v-model="scope.row.from_date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="结束时间" align="center">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="'tableData.' + scope.$index + '.to_date'"
                                :rules="[
                                    {
                                        required: true,
                                        message: '请选择结束时间',
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-date-picker
                                    type="date"
                                    v-model="scope.row.to_date"
                                    placeholder="选择日期"
                                    value-format="yyyy-MM-dd"
                                    format="yyyy-MM-dd"
                                ></el-date-picker>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="价格(元/单位)" align="center">
                        <template slot-scope="scope">
                            <el-form-item
                                :prop="
                                    'tableData.' + scope.$index + '.pay_price'
                                "
                                :rules="[
                                    {
                                        required: true,
                                        message: '请输入价格',
                                        trigger: 'blur'
                                    }
                                ]"
                            >
                                <el-input
                                    v-model="scope.row.pay_price"
                                    maxlength="10"
                                    v-Int.float
                                ></el-input>
                            </el-form-item>
                        </template>
                    </el-table-column>
                    <el-table-column label="修改" align="center" width="150">
                        <template slot-scope="scope">
                            <div>
                                <el-button
                                    type="danger"
                                    size="small"
                                    @click="deleteItem(scope.row)"
                                    >删除</el-button
                                >
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button
                    size="small"
                    class="leader-common-button"
                    @click="innerSave"
                    >保存</el-button
                >
            </div>
        </el-dialog>
    </div>
</template>
<script>
import Tree from "@/comon/components/tree.vue";
import pagination from "@/comon/components/pagination.vue";
import * as api from "@/http/api.js";
export default {
    components: {
        "me-tree": Tree,
        pagination
    },
    data() {
        return {
            treeData: [],
            treeLoading: false,
            defaultProps: {
                children: "childList",
                label: "class_name"
            },
            checkStrictly: true,
            defaultCheckKeys: [],
            selectPointClassId: "",
            tableData: [],
            paginationData: {
                pageNum: 1,
                pageSize: 10,
                totalNum: ""
            },
            outTitle: "新增",
            outVisible: false,
            outForm: {
                pay_unit_price_id: "", //主键
                pay_unit_price_name: "", //价格名称
                remark: "" //备注
            },
            outFormRules: {
                pay_unit_price_name: [
                    {
                        required: true,
                        message: "请输入价格名称",
                        trigger: "blur"
                    }
                ]
            },
            selectPriceName: "",
            innerVisible: false,
            innerForm: {
                tableData: []
            },
            selectPayUnitPriceId: ""
        };
    },
    mounted() {
        this.getCustomerPointClassList();
    },
    methods: {
        /**
         * @description: 左侧列表
         */
        getCustomerPointClassList() {
            api.getCustomerPointClassList().then(res => {
                if (res && res.error_code == 0) {
                    this.treeData = res.bus_json;
                    if (this.treeData.length > 0) {
                        this.defaultCheckKeys = [
                            this.treeData[0].point_class_id
                        ];
                        this.selectPointClassId = this.defaultCheckKeys[0];
                        this.getPayUnitPriceList();
                    }
                }
            });
        },
        handleTreeNodeClick(select) {
            this.defaultCheckKeys = this.$refs.myTree.$refs.tree.getCheckedKeys();
            this.selectPointClassId = select.point_class_id;
            this.getPayUnitPriceList();
        },
        /**
         * @description: 获取列表
         */
        getPayUnitPriceList() {
            api.getPayUnitPriceList({
                pageNum: this.paginationData.pageNum,
                pageSize: this.paginationData.pageSize,
                point_class_id: this.selectPointClassId
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.tableData = res.bus_json.items;
                    this.paginationData.pageNum = res.bus_json.pageNum;
                    this.paginationData.pageSize = res.bus_json.pageSize;
                    this.paginationData.totalNum = res.bus_json.totalNum;
                }
            });
        },
        paginationDataNew(sth) {
            this.paginationData = sth;
        },
        /// 新增修改列表
        addEdit(title, row) {
            this.outTitle = title;
            this.outVisible = true;
            if (title == "修改") {
                this.outForm = { ...row };
            } else {
                this.outForm.pay_unit_price_id = "";
                this.outForm.pay_unit_price_name = "";
                this.outForm.remark = "";
            }
        },
        outSave() {
            this.$refs["outForm"].validate(valid => {
                if (valid) {
                    api.savePayUnitPrice({
                        point_class_id: this.selectPointClassId,
                        ...this.outForm
                    }).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.closeOutDialog();
                            this.getPayUnitPriceList();
                        }
                    });
                }
            });
        },
        // 删除
        deleteRow(row) {
            this.$confirm("确定删除这条数据吗?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                api.deletePayUnitPrice({
                    pay_unit_price_id: row.pay_unit_price_id
                }).then(res => {
                    if (res && res.error_code === "0") {
                        // 最后一页，只有一条数据时，点击删除
                        if (
                            this.paginationData.totalNum -
                                (this.paginationData.pageNum - 1) *
                                    this.paginationData.pageSize ==
                            1
                        ) {
                            // 处理页码显示问题
                            this.paginationData.pageNum =
                                this.paginationData.pageNum == 1
                                    ? this.paginationData.pageNum
                                    : this.paginationData.pageNum - 1;
                        }
                        this.getPayUnitPriceList();
                        this.$message({
                            message: "删除成功",
                            type: "success"
                        });
                    }
                });
            });
        },
        // 弹窗关闭
        closeOutDialog() {
            this.outVisible = false;
            this.$refs["outForm"].resetFields();
            this.$refs["outForm"].clearValidate();
        },
        // 价格
        priceClick(row) {
            this.selectPriceName = row.pay_unit_price_name;
            this.selectPayUnitPriceId = row.pay_unit_price_id;
            api.getPayUnitPrices({
                pay_unit_price_id: row.pay_unit_price_id
            }).then(res => {
                if (res && res.error_code == 0) {
                    this.innerVisible = true;
                    this.innerForm.tableData = res.bus_json;
                }
            });
        },
        // 动态添加
        handleAddItem() {
            let emptyItem = {
                pay_unit_price_id: this.selectPayUnitPriceId,
                pay_unit_price_dtl_id: "",
                from_date: "",
                to_date: "",
                pay_price: ""
            };
            this.innerForm.tableData.push(emptyItem);
        },
        // 动态删除
        deleteItem(sth) {
            this.$confirm("确认删除这条数据吗？", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(_ => {
                this.innerForm.tableData.forEach(function(item, index, arr) {
                    if (item == sth) {
                        arr.splice(index, 1);
                    }
                });
            });
        },
        // 维护保存
        innerSave() {
            this.$refs["innerForm"].validate(valid => {
                if (valid) {
                    api.savePriceList(this.innerForm.tableData).then(res => {
                        if (res && res.error_code == 0) {
                            this.$message({
                                type: "success",
                                message: res.error_msg
                            });
                            this.closeInnerDialog();
                            this.getPayUnitPriceList();
                        }
                    });
                }
            });
        },
        closeInnerDialog() {
            this.innerVisible = false;
            this.$refs["innerForm"].resetFields();
            this.$refs["innerForm"].clearValidate();
        }
    }
};
</script>
<style lang="scss">
.pay_unit_price {
    width: 100%;
    height: 100%;
    padding-right: 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: row;
    .tree-wrap {
        z-index: 0;
        margin: 0 20px;
        width: 280px;
        height: 100%;
        overflow: hidden;
        box-sizing: border-box;
        border-radius: 5px;
    }
    .custom-table {
        .el-form-item {
            margin-bottom: 0px !important;
        }
    }
}
</style>
